<template>
  <div class="empty">
      <img class="empty-image" src="@/assets/images/empty.png" alt="">
      <p class="empty-text">{{text}}</p>
  </div>
</template>

<script>
export default {
    name:'Empty',
    props:{
        text:String
    },
    data(){
        return {
            
        }
    }
}
</script>

<style lang="less" scoped>
.empty{
    margin-top: 65px;
    text-align: center;
    .empty-image{
        width: 280px;
        height: 240px;
    }
    .empty-text{
        font-size: 30px;
        color: #333333;
        margin-top: 56px;
        letter-spacing:2px;
    }
}
</style>